const Tabs = [
    {
        id:1,
        name:"Overview",
        color:"#000"
    }
]

export default Tabs